import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { inputCls, btnPrimary } from "@/components/admin/ui";

export function PushAdmin() {
  const [stats, setStats] = useState(null);
  const [codes, setCodes] = useState([]);
  const [f, setF] = useState({ title: "", body: "", institution_code: "" });
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/admin/push/stats").then((r) => setStats(r.data));
  useEffect(() => { load(); api.get("/admin/invitations").then((r) => setCodes(r.data)).catch(() => {}); }, []);
  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/push/broadcast", { ...f, institution_code: f.institution_code || null });
      toast.success(`Terkirim ke ${data.sent} dari ${data.targets} perangkat`); setF({ title: "", body: "", institution_code: "" }); load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="admin-push">
      {stats && <div className="flex flex-wrap gap-2 text-xs" data-testid="admin-push-stats"><span className="rounded-full bg-muted px-3 py-1"><b>{stats.users}</b> siswa berlangganan</span><span className="rounded-full bg-muted px-3 py-1"><b>{stats.subscriptions}</b> perangkat</span>{Object.entries(stats.per_institution).map(([k, v]) => <span key={k} className="rounded-full bg-muted px-3 py-1">{k}: {v}</span>)}</div>}
      <div className="soft-card space-y-3 p-5">
        <p className="text-sm font-medium">Kirim pengumuman ke HP siswa</p>
        <input data-testid="push-title-input" placeholder="Judul (mis. Jadwal JLPT Desember)" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className={inputCls} />
        <textarea data-testid="push-body-input" placeholder="Isi pesan singkat…" rows={3} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} className={inputCls} />
        <select data-testid="push-institution-select" value={f.institution_code} onChange={(e) => setF({ ...f, institution_code: e.target.value })} className={inputCls}>
          <option value="">Semua siswa</option>
          {codes.map((c) => <option key={c.code} value={c.code}>{`${c.code} — ${c.institution_name}`}</option>)}
        </select>
        <button data-testid="push-send-button" disabled={busy || f.title.length < 2 || f.body.length < 2} onClick={send} className={btnPrimary}>Kirim notifikasi</button>
      </div>
      {stats?.history?.length > 0 && (
        <div className="soft-card divide-y divide-border" data-testid="admin-push-history">
          {stats.history.map((h) => <div key={h.id} className="px-5 py-3 text-sm"><p className="font-medium">{h.title} <span className="text-xs font-normal text-muted-foreground">· {h.institution_code || "semua"} · {h.sent}/{h.targets} terkirim</span></p><p className="text-xs text-muted-foreground">{h.body}</p></div>)}
        </div>
      )}
    </div>
  );
}
